export default "__VITE_ASSET__LuVBWraK__"